import React from "react";
import { Button, Modal } from "reactstrap";
import { BsCheck, BsX, BsInfoCircleFill } from "react-icons/bs";

const MAXIMO_FALHAS_DETALHADAS = 5;

const TEXTOS = {
  aprovar: {
    parcial: "Aprovação parcial",
    nenhuma: "Aprovação não realizada",
    sucesso: ["aprovada", "aprovadas"],
    falha: ["não aprovada", "não aprovadas"],
  },
  estornar: {
    parcial: "Estorno parcial",
    nenhuma: "Estorno não realizado",
    sucesso: ["estornada", "estornadas"],
    falha: ["não estornada", "não estornadas"],
  },
};

function plural(n, [singular, pluralTexto]) {
  return `${n} ${n === 1 ? singular : pluralTexto}`;
}

function agruparPorMensagem(falhas) {
  return falhas.reduce((grupos, falha) => {
    const grupo = grupos.find((g) => g.mensagem === falha.mensagem);
    if (grupo) {
      grupo.falhas.push(falha);
    } else {
      grupos.push({ mensagem: falha.mensagem, falhas: [falha] });
    }
    return grupos;
  }, []);
}

const ModalResultadoLote = ({ resultado, toggle }) => {
  if (!resultado) return null;

  const { acao, sucessos, falhas } = resultado;
  const textos = TEXTOS[acao];
  const grupos = agruparPorMensagem(falhas);

  return (
    <Modal isOpen={true} toggle={toggle} backdrop={true}>
      <div className="cp-lote-topo">
        <div className="cp-lote-cabecalho">
          <div className="cp-lote-icone">!</div>
          <div className="cp-lote-resumo">
            <h5 className="cp-lote-titulo">
              {sucessos > 0 ? textos.parcial : textos.nenhuma}
            </h5>
            <div className="cp-lote-badges">
              {sucessos > 0 && (
                <span className="cp-lote-badge">
                  <BsCheck className="cp-lote-badge-icone" />
                  {plural(sucessos, textos.sucesso)}
                </span>
              )}
              <span className="cp-lote-badge">
                <BsX className="cp-lote-badge-icone" />
                {plural(falhas.length, textos.falha)}
              </span>
            </div>
          </div>
          <button type="button" className="close" onClick={toggle}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>

      <div className="cp-lote-corpo">
        {grupos.map((grupo) => {
          const detalhadas = grupo.falhas.slice(0, MAXIMO_FALHAS_DETALHADAS);
          const restantes = grupo.falhas.length - detalhadas.length;
          return (
            <div key={grupo.mensagem} className="cp-lote-grupo">
              <p className="cp-lote-grupo-mensagem">
                {grupo.mensagem}{" "}
                <span className="cp-lote-grupo-quantidade">
                  ({grupo.falhas.length})
                </span>
              </p>
              <div className="cp-lote-lista">
                {detalhadas.map((falha) => (
                  <div key={falha.conta.id} className="cp-lote-item">
                    <div className="cp-lote-item-campanha">
                      {falha.conta.campanha}
                    </div>
                    <div className="cp-lote-item-empresa">
                      {falha.conta.empresa}
                    </div>
                    {falha.statusAtual && (
                      <div className="cp-lote-item-status">
                        Status atual: {falha.statusAtual}
                      </div>
                    )}
                  </div>
                ))}
                {restantes > 0 && (
                  <div className="cp-lote-restantes">
                    E mais {restantes} conta(s)
                  </div>
                )}
              </div>
            </div>
          );
        })}

        <div className="cp-lote-info">
          <BsInfoCircleFill className="cp-lote-info-icone" />
          {falhas.length === 1
            ? `A conta ${textos.falha[0]} continua selecionada para você revisar.`
            : `As ${falhas.length} contas ${textos.falha[1]} continuam selecionadas para você revisar.`}
        </div>
      </div>

      <div className="cp-lote-rodape">
        <Button onClick={toggle} className="cp-botao-fechar">
          Fechar
        </Button>
      </div>
    </Modal>
  );
};

export default ModalResultadoLote;
